import React from 'react';

const TableCell = ({ children, colSpan }) => {
  return <td colSpan={colSpan}>{children}</td>;
};

export default TableCell;